import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchRequestSubset,
    SearchProviderFieldType, ISearchProviderField
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_User_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_AUTHUSR_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'User WB Id', columnResourceName: 'colUsrWBId', alignment: HorizAlignment.Center},
        domainOptions: {}
    },
    USER_ID_UI: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    USER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'User Name', columnResourceName: 'colName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 256}
    },
    FIRST_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'First Name', columnResourceName: 'colFirstName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    LAST_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Last Name', columnResourceName: 'colLastName', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    LOGIN: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Login', columnResourceName: 'colLogin', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    EMAIL: {
        type: SearchProviderFieldType.string,
        renderOptions: {columnName: 'Email', columnResourceName: 'colEmail', alignment: HorizAlignment.Left},
        domainOptions: {maxLength: 50}
    },
    PROVIDER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Provider Name',
            columnResourceName: 'colProviderName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 256}
    },
    PROVIDER_SORT: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Provider Sort',
            columnResourceName: 'colProviderSort',
            alignment: HorizAlignment.Left
        },
        domainOptions: {maxLength: 50}
    },
    CREATE_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreatedDate',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {maxLength: 50}
    },
    MODIFIED_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDate',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {maxLength: 50}
    },
}

var UserSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_AUTHUSR_ID',
        id_ui: 'USER_ID_UI',
        name: 'USER_NAME'
    },

    searchProviderFields: vUI_User_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_User_Search_Basic',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


var UserSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "UserSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'USER_ID_UI', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'USER_NAME', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'USER_ID_UI', 'USER_NAME', 'FIRST_NAME', 'LAST_NAME', 'PROVIDER_NAME', 'CREATE_DT', 'MODIFIED_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UserSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var UserSearchProfileByNameEmail: ISearchProfile = {
    profileId: "profile2",
    profileName: "Search by Id, Name, Email",
    renderOptions: {ui5ResourceId: "UserSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'USER_ID_UI', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'USER_NAME', renderOptions: {}},
        {profileFilterName: 'E-mail', searchProviderFieldId: 'EMAIL', renderOptions: {}}
    ],  // ISearchFields
    profileDisplayFields: [
        'USER_ID_UI', 'USER_NAME', 'FIRST_NAME', 'PROVIDER_NAME', 'CREATE_DT', 'MODIFIED_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: UserSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var UserSearch: ISearch = {
    searchName: "Find User",
    renderOptions: {ui5ResourceId: "UserSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [UserSearchProfileByName, UserSearchProfileByNameEmail]
}
PAEnvironment.registerBusinessObjectSearch("UserBO", "User", UserSearch, "User Search")

export {UserSearch}